module.exports = __webpack_public_path__ + "img/bao_fyldt.947a51ad.jpg";